import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

const I18nContext = createContext({ lang: "it", setLang: () => {}, t: translations.it });

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "it";
    return localStorage.getItem("pb_lang") || "it";
  });

  useEffect(() => {
    localStorage.setItem("pb_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const value = { lang, setLang, t: translations[lang] };
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
